

export default class {
    constructor($section, $bodyHtml) {
        this.$section = $section;
        this.$bodyHtml = $bodyHtml;
        this.$height = this.$section.children().first();
        this.isOpen = false;
        $section.find('[data-close-form]').click(()=>{
            this.close();
        });
    }
    addTrigger($trigger) {
        $trigger.click(()=>{
            /* temp always open - todo: add close button on form */
            this.open();
            return false;

            // this.isOpen = ! this.isOpen;
            // if (this.isOpen) {
            //     this.open();
            // } else {
            //     this.close();
            // }
            // return false;
        });
    }
    open() {
        this.isOpen = true;
        this.$section.css('display', 'block');
        setTimeout(()=>{
            let height = this.$height.outerHeight();
            this.$section.css('height', height + 'px');
        }, 10);
        setTimeout(()=>{
            this.$section.css('height', 'auto');
            let pos = this.$section.offset().top;
            this.$bodyHtml.stop().animate({
                scrollTop: pos,
            }, 1200, 'swing');
        }, 600);
    }
    close() {
        this.isOpen = false;
        let height = this.$height.outerHeight();
        this.$section.css('height', height + 'px');
        setTimeout(()=>{
            this.$section.css('height', 0);
        }, 10);
        setTimeout(()=>{
            this.$section.css('display', 'none');
        }, 800);
    }
}


// WEBPACK FOOTER //
// ./scripts/lib/OpenSection.js